"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConnect = exports.connectInstallationFlow = exports.handleTransfers = void 0;
var index_1 = require("../index");
var connect_sdk_js_1 = require("@ibm-aspera/connect-sdk-js");
var transferMonitorActivated = false;
var installerFlowActivated = false;
/**
 * Connect Core Logic
 *
 * @remarks
 * Most logic is called directly by Desktop SDK functions
 * You may not need to import anything from this file.
 */
var handleTransfers = function (transfers) {
    transfers.forEach(function (t) {
        t.transfer_client = 'connect';
    });
    index_1.asperaSdk.activityTracking.handleTransferActivity({
        type: 'transferUpdated',
        data: { transfers: transfers },
    });
};
exports.handleTransfers = handleTransfers;
var connectInstallationFlow = function () {
    if (installerFlowActivated) {
        return;
    }
    installerFlowActivated = true;
    var handleInstallerEvent = function (eventType, eventStatus) {
        // Verify that the event matches
        if (index_1.asperaSdk.globals.connectAW4.Connect.EVENT.STATUS !== eventType) {
            return;
        }
        // Depending on status show the proper installer screen
        switch (eventStatus) {
            case index_1.asperaSdk.globals.connectAW4.Connect.STATUS.INITIALIZING:
                index_1.asperaSdk.globals.connectInstaller.showLaunching();
                break;
            case index_1.asperaSdk.globals.connectAW4.Connect.STATUS.EXTENSION_INSTALL:
                index_1.asperaSdk.globals.connectInstaller.showExtensionInstall();
                break;
            case index_1.asperaSdk.globals.connectAW4.Connect.STATUS.FAILED:
                index_1.asperaSdk.globals.connectInstaller.showDownload();
                break;
            case index_1.asperaSdk.globals.connectAW4.Connect.STATUS.OUTDATED:
                index_1.asperaSdk.globals.connectInstaller.showUpdate();
                break;
            case index_1.asperaSdk.globals.connectAW4.Connect.STATUS.RUNNING:
                index_1.asperaSdk.globals.connectInstaller.connected();
                break;
        }
    };
    index_1.asperaSdk.globals.connect.addEventListener(index_1.asperaSdk.globals.connectAW4.Connect.EVENT.STATUS, handleInstallerEvent);
};
exports.connectInstallationFlow = connectInstallationFlow;
var initConnect = function (connectSettings) {
    index_1.asperaSdk.globals.connect = new connect_sdk_js_1.Connect({
        minVersion: connectSettings.minVersion || '3.10.1',
        dragDropEnabled: connectSettings.dragDropEnabled,
        connectMethod: connectSettings.method,
    });
    index_1.asperaSdk.globals.connectInstaller = new connect_sdk_js_1.ConnectInstaller({
        sdkLocation: connectSettings.sdkLocation,
        correlationId: connectSettings.correlationId,
        style: 'carbon',
        version: connectSettings.version,
    });
    index_1.asperaSdk.globals.connectAW4 = {
        Connect: connect_sdk_js_1.Connect,
        ConnectInstaller: connect_sdk_js_1.ConnectInstaller,
    };
    index_1.asperaSdk.globals.connect.addEventListener(connect_sdk_js_1.Connect.EVENT.STATUS, function (eventType, eventStatus) {
        if (eventType === connect_sdk_js_1.Connect.EVENT.STATUS) {
            index_1.asperaSdk.globals.connectStatus = eventStatus;
            index_1.asperaSdk.activityTracking.sendManualEventCallback(eventStatus);
            if (eventStatus === 'RUNNING' && !transferMonitorActivated) {
                transferMonitorActivated = true;
                index_1.asperaSdk.globals.connect.addEventListener(connect_sdk_js_1.Connect.EVENT.TRANSFER, function (_event, data) {
                    (0, exports.handleTransfers)(data.transfers);
                });
            }
        }
    });
    index_1.asperaSdk.globals.connect.initSession(index_1.asperaSdk.globals.appId);
    if (!connectSettings.hideIncludedInstaller) {
        (0, exports.connectInstallationFlow)();
    }
    return Promise.resolve({ connectMode: true });
};
exports.initConnect = initConnect;
